export default {
	"1e42ed0a7c08b9483c6b6eab3a6dd33d": "商品详情页_优惠券点击"
}
